import React from "react";

interface ScheduleSuccessIconProps {
  className?: string;
  onClick?: () => void;
}

export const ScheduleSuccessIcon = ({
  className,
  onClick,
}: ScheduleSuccessIconProps) => (
  <svg
    className={className}
    onClick={onClick}
    width="109"
    height="76"
    viewBox="0 0 109 76"
    fill="none"
  >
    <path
      opacity="0.3"
      d="M1.27186 59.796C-2.00568 47.0184 1.81814 40.2746 4.13973 37.6808C9.63825 31.5377 17.2499 35.0189 37.1199 19.6611C53.9526 6.65089 64.3352 -7.57781 85.0539 12.0846C117.42 42.8001 85.0539 76.9967 67.0275 71.6727C50.9317 66.9189 44.3578 67.5773 39.9878 69.625C18.2741 79.454 5.36878 75.7681 1.27186 59.796Z"
      fill="#D9E7F0"
    />
    <path
      d="M104.102 38.5627C100.32 40.439 95.2998 38.0265 95.2998 38.0265C95.2998 38.0265 96.4156 32.5731 100.2 30.6993C103.982 28.823 109 31.2329 109 31.2329C109 31.2329 107.885 36.6864 104.102 38.5627Z"
      fill="#E8EAEF"
    />
    <path
      d="M3.50922 22.6222C2.43995 22.6222 1.57313 21.7554 1.57313 20.6861C1.57313 19.6168 2.43995 18.75 3.50922 18.75C4.5785 18.75 5.44531 19.6168 5.44531 20.6861C5.44531 21.7554 4.5785 22.6222 3.50922 22.6222Z"
      fill="#E8EAEF"
    />
    <path
      d="M84.3628 72.2296C83.7212 72.2296 83.2011 71.7095 83.2011 71.0679C83.2011 70.4263 83.7212 69.9062 84.3628 69.9062C85.0043 69.9062 85.5244 70.4263 85.5244 71.0679C85.5244 71.7095 85.0043 72.2296 84.3628 72.2296Z"
      fill="#E8EAEF"
    />
    <path
      d="M11.8762 11.0716C12.0584 11.7518 11.6548 12.4509 10.9746 12.6332C10.2944 12.8154 9.59527 12.4118 9.41301 11.7316C9.23076 11.0514 9.63441 10.3523 10.3146 10.17C10.9948 9.98774 11.6939 10.3914 11.8762 11.0716Z"
      fill="#E8EAEF"
    />
    <path
      d="M43.9122 8.97435C42.9755 8.97435 42.2161 8.21496 42.2161 7.27819C42.2161 6.34143 42.9755 5.58203 43.9122 5.58203C44.849 5.58203 45.6084 6.34143 45.6084 7.27819C45.6084 8.21496 44.849 8.97435 43.9122 8.97435Z"
      fill="#E8EAEF"
    />
    <path
      d="M84.4763 3.09583C84.8556 4.51144 84.0155 5.96651 82.5999 6.34583C81.1843 6.72514 79.7292 5.88505 79.3499 4.46944C78.9706 3.05383 79.8107 1.59876 81.2263 1.21945C82.6419 0.840134 84.097 1.68022 84.4763 3.09583Z"
      fill="#E8EAEF"
    />
    <path
      d="M91.7227 60.1719H91.7568C91.9589 63.0357 94.0887 63.0798 94.0887 63.0798C94.0887 63.0798 91.7401 63.1257 91.7401 66.4347C91.7401 63.1257 89.3916 63.0798 89.3916 63.0798C89.3916 63.0798 91.5205 63.0357 91.7227 60.1719ZM17.5832 69.4062H17.6135C17.7927 71.9982 19.6826 72.0382 19.6826 72.0382C19.6826 72.0382 17.5986 72.0797 17.5986 75.0746C17.5986 72.0797 15.5146 72.0382 15.5146 72.0382C15.5146 72.0382 17.4038 71.9982 17.5832 69.4062Z"
      fill="#E8EAEF"
    />
    <path
      d="M50.3164 63.1563C63.8453 63.1563 74.8126 52.189 74.8126 38.6602C74.8126 25.1314 63.8453 14.1641 50.3164 14.1641C36.7876 14.1641 25.8203 25.1314 25.8203 38.6602C25.8203 52.189 36.7876 63.1563 50.3164 63.1563Z"
      fill="#85DFA9"
    />
    <path
      d="M58.9602 33.918L48.0966 44.9817L41.5742 38.3446"
      stroke="white"
      strokeWidth="6.17824"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

ScheduleSuccessIcon.defaultProps = {
  className: "",
  onClick: undefined,
};
